import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useFirmContext } from '../providers/FirmProvider';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { useIsActiveSubscription } from '../hooks/use-is-active-subscription';
import { useIsWorkpaperRole } from '../hooks/use-is-workpaper-role';
import { useState } from 'react';
import XeroErrorAlert from '../components/XeroErrorAlert';
import NewOrEditJournalForm from '../features/new-or-edit-journal/NewOrEditJournalForm';

function NewJournalPage(): JSX.Element {
    const navigate = useNavigate();
    const activeSubscription = useIsActiveSubscription();
    const { shortId } = useFirmContext();
    const { isGuest } = useIsWorkpaperRole();
    const { id: workpaperId, entity } = useWorkpaperContext();
    const [params] = useSearchParams();
    const [xeroError, setXeroError] = useState<{ name: string; message: string } | undefined>();

    if (!activeSubscription || isGuest) {
        return <Navigate to=".." />;
    }

    function handleCreate(id: string): void {
        navigate(`/${shortId}/workpapers/${workpaperId}/journals/${id}`);
    }

    function handleReturnToTable(): void {
        navigate(`/${shortId}/workpapers/${workpaperId}/journals${params && `?${params}`}`);
    }

    return (
        <>
            {xeroError && (
                <div className="w-fit mx-auto mb-8">
                    <XeroErrorAlert
                        message={xeroError.message}
                        errorName={xeroError.name}
                        entityName={entity?.name}
                        entityId={entity?.id}
                    />
                </div>
            )}
            <NewOrEditJournalForm
                onCreate={handleCreate}
                onReturn={handleReturnToTable}
                onCancel={handleReturnToTable}
                onXeroError={setXeroError}
            />
        </>
    );
}

export default NewJournalPage;
